/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Reference_HeadingInputs */

const en_endpoint_reference_heading = /** @type {((inputs: Endpoint_Reference_HeadingInputs) => LocalizedString) & { parts: (inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Reference_HeadingInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`One request, one response shape.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "One request" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }, { type: "text", value: ", one response shape." }])
			})
		}
	)
);

const zh_hans1_endpoint_reference_heading = /** @type {((inputs: Endpoint_Reference_HeadingInputs) => LocalizedString) & { parts: (inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Reference_HeadingInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`一个请求，一种响应结构。`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "一个请求" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }, { type: "text", value: "，一种响应结构。" }])
			})
		}
	)
);

const pt_br2_endpoint_reference_heading = /** @type {((inputs: Endpoint_Reference_HeadingInputs) => LocalizedString) & { parts: (inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Reference_HeadingInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Uma requisição, um formato de resposta.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "Uma requisição" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }, { type: "text", value: ", um formato de resposta." }])
			})
		}
	)
);

const es_endpoint_reference_heading = /** @type {((inputs: Endpoint_Reference_HeadingInputs) => LocalizedString) & { parts: (inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Reference_HeadingInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Una solicitud, un formato de respuesta.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "Una solicitud" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }, { type: "text", value: ", un formato de respuesta." }])
			})
		}
	)
);

const fr_endpoint_reference_heading = /** @type {((inputs: Endpoint_Reference_HeadingInputs) => LocalizedString) & { parts: (inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Reference_HeadingInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Une requête, une seule forme de réponse.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "Une requête" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }, { type: "text", value: ", une seule forme de réponse." }])
			})
		}
	)
);

const de_endpoint_reference_heading = /** @type {((inputs: Endpoint_Reference_HeadingInputs) => LocalizedString) & { parts: (inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Reference_HeadingInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Eine Anfrage, eine Antwortstruktur.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "Eine Anfrage" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }, { type: "text", value: ", eine Antwortstruktur." }])
			})
		}
	)
);

const ru_endpoint_reference_heading = /** @type {((inputs: Endpoint_Reference_HeadingInputs) => LocalizedString) & { parts: (inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Reference_HeadingInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Один запрос, один формат ответа.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "Один запрос" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }, { type: "text", value: ", один формат ответа." }])
			})
		}
	)
);

const it_endpoint_reference_heading = /** @type {((inputs: Endpoint_Reference_HeadingInputs) => LocalizedString) & { parts: (inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Reference_HeadingInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Una richiesta, una sola forma di risposta.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Reference_HeadingInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "muted", options: {}, attributes: {} }, { type: "text", value: "Una richiesta" }, { type: "markup-end", name: "muted", options: {}, attributes: {} }, { type: "text", value: ", una sola forma di risposta." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "One request, one response shape." |
*
* @param {Endpoint_Reference_HeadingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_heading = /** @type {((inputs?: Endpoint_Reference_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs?: Endpoint_Reference_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Endpoint_Reference_HeadingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { muted: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Endpoint_Reference_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_endpoint_reference_heading(inputs)
			if (locale === "pt-BR") return pt_br2_endpoint_reference_heading(inputs)
			if (locale === "es") return es_endpoint_reference_heading(inputs)
			if (locale === "fr") return fr_endpoint_reference_heading(inputs)
			if (locale === "de") return de_endpoint_reference_heading(inputs)
			if (locale === "ru") return ru_endpoint_reference_heading(inputs)
			if (locale === "it") return it_endpoint_reference_heading(inputs)
			return en_endpoint_reference_heading(inputs)
		}),
		{
			parts: /** @type {(inputs?: Endpoint_Reference_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_endpoint_reference_heading.parts === "function" ? zh_hans1_endpoint_reference_heading.parts(inputs) : [{ type: "text", value: zh_hans1_endpoint_reference_heading(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_endpoint_reference_heading.parts === "function" ? pt_br2_endpoint_reference_heading.parts(inputs) : [{ type: "text", value: pt_br2_endpoint_reference_heading(inputs) }]
				if (locale === "es") return typeof es_endpoint_reference_heading.parts === "function" ? es_endpoint_reference_heading.parts(inputs) : [{ type: "text", value: es_endpoint_reference_heading(inputs) }]
				if (locale === "fr") return typeof fr_endpoint_reference_heading.parts === "function" ? fr_endpoint_reference_heading.parts(inputs) : [{ type: "text", value: fr_endpoint_reference_heading(inputs) }]
				if (locale === "de") return typeof de_endpoint_reference_heading.parts === "function" ? de_endpoint_reference_heading.parts(inputs) : [{ type: "text", value: de_endpoint_reference_heading(inputs) }]
				if (locale === "ru") return typeof ru_endpoint_reference_heading.parts === "function" ? ru_endpoint_reference_heading.parts(inputs) : [{ type: "text", value: ru_endpoint_reference_heading(inputs) }]
				if (locale === "it") return typeof it_endpoint_reference_heading.parts === "function" ? it_endpoint_reference_heading.parts(inputs) : [{ type: "text", value: it_endpoint_reference_heading(inputs) }]
				return typeof en_endpoint_reference_heading.parts === "function" ? en_endpoint_reference_heading.parts(inputs) : [{ type: "text", value: en_endpoint_reference_heading(inputs) }]
			})
		}
	)
);